import type {ColumnsSetting, FeGridSettings} from '../types/Api';
import {areColumnsAndSettingsEqual} from './isVirtualPresetEqual';

type CustomPresetSnapshot = {
  columnsSettings: ColumnsSetting[];
  gridSettings: FeGridSettings;
  queryId: string;
};

/**
 * Compares a saved custom preset snapshot against the current grid state.
 *
 * Returns `true` if the user has made unsaved changes (columns, settings, or filters/sort).
 *
 * - Columns + settings: delegates to `areColumnsAndSettingsEqual`.
 * - Filters/sort (captured via queryId): dirty when `saved.queryId !== current.queryId`
 */
export function isCustomPresetDirty(
  saved: CustomPresetSnapshot,
  current: CustomPresetSnapshot
): boolean {
  if (saved.queryId !== current.queryId) {
    return true;
  }

  return !areColumnsAndSettingsEqual(saved, current);
}
